import Axios from 'axios'
import { get } from '@bigyouth/base'
import scrollManager from '../utils/scrollManager'
import onResize from '../utils/onResize'

export default {
  name: 'search',

  ui: {
    'input': '[js-search-input]',
    'panel': '[js-search-panel]',
    'toggle': '[js-search-toggle]',
    'close': '[js-search-panel-close]',
    'results': '[js-search-panel-results]',
    'products': '[js-search-products]',
    'articles': '[js-search-articles]',
    'numberArticles': '[js-search-number-articles]',
    'numberProducts': '[js-search-number-Products]',
  },

  isFR: !window.location.origin.includes('en.statement'),
  timeout: null,

  state: {
    query: '',
  },

  events: [
    {
      target: 'close',
      on: 'click',
      handle () {
        this.ui.panel.classList.remove('is-visible')
        document.querySelector('.header').classList.remove('is-open')
        scrollManager.restart()

        this.reset()
      },
    },
    {
      target: 'toggle',
      on: 'click',
      handle () {
        this.ui.panel.classList.toggle('is-visible')
        document.querySelector('.header').classList.toggle('is-open')
        document.querySelector('.header').classList.remove('is-active')

        setTimeout(() => {
          if (this.ui.panel.classList.contains('is-visible')) {
            this.ui.input.focus()
          }
        }, 200)
      },
    },
    {
      target: 'input',
      on: ['keyup'],
      handle (elt) {
        if (this.timeout !== null) {
          clearTimeout(this.timeout)
        }

        this.timeout = setTimeout(() => {
          if (elt.target.value.length > 0) {
            this.search(elt.target.value)
            this.ui.results.classList.add('is-visible')

            scrollManager.stop()
          } else {
            this.reset()
            scrollManager.restart()
          }
        }, 500)
      },
    },
  ],

  reset () {
    this.ui.input.value = ''
    this.ui.products.innerHTML = ''
    this.ui.articles.innerHTML = ''
    this.ui.numberArticles.innerHTML = '(0)'
    this.ui.numberProducts.innerHTML = '(0)'
    this.ui.results.classList.remove('is-visible')
  },

  search (q) {
    this.ui.results.classList.add('is-loading')

    // get products
    Axios.get(`https://services.mybcapps.com/bc-sf-filter/search?q=${q}&shop=statement-paris.myshopify.com&limit=70&page=1`).then(({ status, data }) => {
      // REMOVE LOAD
      if (status === 200) {
        const productsNb = data.products.length

        if (productsNb > 0) {
          this.displayProducts(data.products)
        } else {
          this.ui.numberProducts.innerHTML = '(0)'
          this.ui.products.innerHTML = `<p class="col-product no-results">${this.ui.panel.dataset.noResults}</p>`
        }

        // get pages
        Axios.get(`https://services.mybcapps.com/bc-sf-filter/search/pages?q=${q}&shop=statement-paris.myshopify.com&limit=70&page=1`).then(({ status, data }) => {
          // REMOVE LOAD
          if (status === 200) {
            const pages = data.pages.filter(page => (this.isFR) ? page.url.includes('/journal/') : page.url.includes('/blog/'))

            if (pages.length > 0) {
              this.displayArticles(pages)
            } else {
              this.ui.numberArticles.innerHTML = '(0)'
              this.ui.articles.innerHTML = `<p>${this.ui.panel.dataset.noResults}</p>`
            }

            if (productsNb === 0 && pages.length > 0) {
              get('[js-tabs-trigger][data-tab="articles"]').click()
            } else {
              get('[js-tabs-trigger][data-tab="products"]').click()
            }

            this.ui.results.classList.remove('is-loading')
          }
        }).catch((e) => {
          console.log(`Something wrong with, ${e}`)
        })
      }
    }).catch((e) => {
      console.log(`Something wrong with, ${e}`)
    })
  },

  componentDidMount () {
    this.off = onResize(this.onResize.bind(this))

    this.calcHeight()

    window.addEventListener('orientationchange', () => {
      this.calcHeight()
    })
  },

  componentWillUnmount () {
    this.off()
  },

  onResize () {
    this.calcHeight()
  },

  imageUrl (src, size) {
    // remove any current image size then add the new image size
    return src
      .replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
        return '_' + size + match
      })
  },

  displayArticles (articles) {
    this.ui.articles.innerHTML = ''

    this.ui.numberArticles.innerHTML = `(${articles.length})`

    articles.forEach(article => {
      let itemHtml = document.createElement('div')
      itemHtml.classList.add('search-article')

      itemHtml.innerHTML = `
        <a href="${article.url}" class="product-card flex flex-col">
          <div class="aspect-ratio aspect-ratio--wide aspect-ratio--67-100">
              <picture>
                  <source media="(max-width: 414px)" data-srcset="${this.imageUrl(article.image.src, '342x230')}, ${this.imageUrl(article.image.src, '684x460')} 2x">
                  <source media="(max-width: 767px)" data-srcset="${this.imageUrl(article.image.src, '637x427')}, ${this.imageUrl(article.image.src, '1274x864')} 2x">
                  <source media="(max-width: 1023px)" data-srcset="${this.imageUrl(article.image.src, '411x265')}, ${this.imageUrl(article.image.src, '822x530')} 2x">
                  <source media="(max-width: 1400px)" data-srcset="${this.imageUrl(article.image.src, '554x371')}, ${this.imageUrl(article.image.src, '1108x742')} 2x">
                  <source media="(max-width: 1600px)" data-srcset="${this.imageUrl(article.image.src, '637x426')}, ${this.imageUrl(article.image.src, '1274x852')} 2x">
                  <source media="(min-width: 1601px)" data-srcset="${this.imageUrl(article.image.src, '770x516')}, ${this.imageUrl(article.image.src, '1540x1032')} 2x">
                  <img class="aspect-ratio__item lazyload" data-src="${this.imageUrl(article.image.src, '770x516')}" alt="${article.title}"/>
              </picture>
          </div>
          <div class="product-card__txt">
              <h3 class="title-2 title-2--bold">${article.title}</h3>
          </div>
        </a>
      `

      this.ui.articles.append(itemHtml)
    })
  },

  displayProducts (products) {
    this.ui.products.innerHTML = ''

    this.ui.numberProducts.innerHTML = `(${products.length})`

    products.forEach(product => {
      /* eslint-disable-next-line */
      let itemHtml = searchTemplates.productItem

      if (!this.isFR) {
        Axios.get(`https://www.statement.paris/products/${product.handle}?view=json`).then(({ status, data }) => {
          itemHtml = itemHtml.replace(/{{title}}/g, data.metafields.titleEN)
          itemHtml = this.replaceProductItemVars(itemHtml, product)

          this.ui.products.innerHTML += itemHtml
        }).catch((e) => {
          console.log(`Something wrong with, ${e}`)
        })
      } else {
        itemHtml = itemHtml.replace(/{{title}}/g, product.title)
        itemHtml = this.replaceProductItemVars(itemHtml, product)

        this.ui.products.innerHTML += itemHtml
      }
    })
  },

  replaceProductItemVars (itemHtml, product) {
    itemHtml = itemHtml.replace(/{{link}}/g, `/products/${product.handle}`)
    itemHtml = itemHtml.replace(/{{price}}/g, product.price_min)
    itemHtml = itemHtml.replace(/{{image1}}/g, this.imageUrl(product.images[1], '342x342'))
    itemHtml = itemHtml.replace(/{{image2}}/g, this.imageUrl(product.images[1], '635x635'))
    itemHtml = itemHtml.replace(/{{image3}}/g, this.imageUrl(product.images[1], '290x290'))
    itemHtml = itemHtml.replace(/{{image4}}/g, this.imageUrl(product.images[1], '402x402'))
    itemHtml = itemHtml.replace(/{{image5}}/g, this.imageUrl(product.images[1], '458x458'))
    itemHtml = itemHtml.replace(/{{image6}}/g, this.imageUrl(product.images[1], '664x664'))
    itemHtml = itemHtml.replace(/{{image1_2x}}/g, this.imageUrl(product.images[1], '684x684'))
    itemHtml = itemHtml.replace(/{{image2_2x}}/g, this.imageUrl(product.images[1], '1270x1270'))
    itemHtml = itemHtml.replace(/{{image3_2x}}/g, this.imageUrl(product.images[1], '580x580'))
    itemHtml = itemHtml.replace(/{{image4_2x}}/g, this.imageUrl(product.images[1], '804x804'))
    itemHtml = itemHtml.replace(/{{image5_2x}}/g, this.imageUrl(product.images[1], '916x916'))
    itemHtml = itemHtml.replace(/{{image6_2x}}/g, this.imageUrl(product.images[1], '1328x1328'))
    itemHtml = itemHtml.replace(/{{image_hover1}}/g, this.imageUrl(product.images[2], '342x342'))
    itemHtml = itemHtml.replace(/{{image_hover2}}/g, this.imageUrl(product.images[2], '635x635'))
    itemHtml = itemHtml.replace(/{{image_hover3}}/g, this.imageUrl(product.images[2], '290x290'))
    itemHtml = itemHtml.replace(/{{image_hover4}}/g, this.imageUrl(product.images[2], '402x402'))
    itemHtml = itemHtml.replace(/{{image_hover5}}/g, this.imageUrl(product.images[2], '458x458'))
    itemHtml = itemHtml.replace(/{{image_hover6}}/g, this.imageUrl(product.images[2], '664x664'))
    itemHtml = itemHtml.replace(/{{image_hover1_2x}}/g, this.imageUrl(product.images[2], '684x684'))
    itemHtml = itemHtml.replace(/{{image_hover2_2x}}/g, this.imageUrl(product.images[2], '1270x1270'))
    itemHtml = itemHtml.replace(/{{image_hover3_2x}}/g, this.imageUrl(product.images[2], '580x580'))
    itemHtml = itemHtml.replace(/{{image_hover4_2x}}/g, this.imageUrl(product.images[2], '804x804'))
    itemHtml = itemHtml.replace(/{{image_hover5_2x}}/g, this.imageUrl(product.images[2], '916x916'))
    itemHtml = itemHtml.replace(/{{image_hover6_2x}}/g, this.imageUrl(product.images[2], '1328x1328'))

    return itemHtml
  },

  calcHeight () {
    let height = window.innerHeight
    let topBanner = get('.top-banner')

    if (topBanner) {
      height -= topBanner.offsetHeight
    }

    height -= get('.header').offsetHeight
    height -= get('.search-panel__top').offsetHeight

    let vh = height * 0.01
    this.ui.results.style.setProperty('--vh', `${vh}px`)
  },
}
